import { APIError } from "../api/ObservableFromFetch"

export default function FormatError(error: Error | APIError): string {
    return (error as APIError)?.errorData?.message || error.message
}
